// @ts-nocheck
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
    zh: {
        translation: {
            "Welcome to React": "Welcome to React and react - i18next",
            "搜索或输入网址": "搜索或输入网址",
            "获取": "获取",
            "查看": "查看"
        }
    },
    en: {
        translation: {
            "搜索或输入网址": "Search or enter URL",
            "获取": "Added",
            "查看": "Gotten",
            "Welcome to React": "Welcome to React and react - i18next"
        }
    },
    fr: {
        translation: {
            "Welcome to React": "Bienvenue à React et react - i18next",
            "搜索或输入网址": "Rechercher ou entrer une URL",
            "获取": "Obtenu",
            "查看": "Voir"
        }
    },
    jp: {
        translation: {
            "Welcome to React": "Reactとreact - i18nextへようこそ",
            "搜索或输入网址": "検索またはURLを入力",
            "获取": "取得する",
            "查看": "確認する"
        }
    },
    kor: {
        translation: {
            "Welcome to React": "React와 react - i18next에 오신 것을 환영합니다",
            "搜索或输入网址": "검색하거나 URL을 입력하세요",
            "获取": "가져오기",
            "查看": "확인"
        }
    },
    th: {
        translation: {
            "Welcome to React": "ยินดีต้อนรับสู่ React และ react - i18next",
            "搜索或输入网址": "ค้นหาหรือป้อน URL",
            "获取": "รับ",
            "查看": "ดู"
        }
    },
    vie: {
        translation: {
            "Welcome to React": "Chào mừng đến với React và react - i18next",
            "搜索或输入网址": "Tìm kiếm hoặc nhập URL",
            "获取": "Lấy",
            "查看": "Xem"
        }
    },
    es: {
        translation: {
            "Welcome to React": "Bienvenido a React y react - i18next",
            "搜索或输入网址": "Buscar o ingresar URL",
            "获取": "Obtener",
            "查看": "Ver"
        }
    },
    ru: {
        translation: {
            "Welcome to React": "Добро пожаловать в React и react - i18next",
            "搜索或输入网址": "Поиск или введите URL",
            "获取": "Получить",
            "查看": "Посмотреть"
        }
    },
    de: {
        translation: {
            "Welcome to React": "Willkommen bei React und react - i18next",
            "搜索或输入网址": "Suchen oder URL eingeben",
            "获取": "Holen",
            "查看": "Ansehen"
        }
    },
    pt: {
        translation: {
            "Welcome to React": "Bem - vindo ao React e ao react - i18next",
            "搜索或输入网址": "Pesquisar ou inserir URL",
            "获取": "Obter",
            "查看": "Ver"
        }
    },
    cht: {
        translation: {
            "Welcome to React": "歡迎使用 React 和 react - i18next",
            "搜索或输入网址": "搜尋或輸入網址",
            "获取": "獲取",
            "查看": "查看"
        }
    }
};

i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        lng: "en", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
        // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
        // if you're using a language detector, do not define the lng option

        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

export default i18n;